<template>
  <div class="register">
    <div class="register_box content_auto">
      <div class="register_content" v-if="reverseRegister">
        <div class="register_card">
          <h1>{{ $t('注册') }}</h1>
          <div class="tabs_box">
            <div
              :class="{ active_tab: shimTab === item.name }"
              v-for="(item, index) in registerList"
              :key="index"
              @click="handleTab(item.name)"
            >
              {{ item.tab }}
            </div>
          </div>

          <el-form :model="dataList" :rules="rules" ref="ruleFormRef">
            <!-- 手机号码注册显示 -->
            <el-form-item
              prop="account"
              :class="{ mobileFormItem: shimTab === 0 }"
            >
              <div
                :class="shimTab === 0 ? 'register_mobile' : 'register_email'"
              >
                <!-- :selectCountry.sync="dataList.areaCode"  -->
                <InternationalCode
                  v-if="shimTab === 0"
                  containerWidth="100px"
                  isCountryDialCode
                  @selectCountry="onSelectCountry"
                ></InternationalCode>
                <div
                  :class="[
                    'input_box',
                    shimTab === 0 ? 'mobile_box' : 'email_box'
                  ]"
                >
                  <el-input
                    v-model="dataList.account"
                    :placeholder="
                      shimTab === 0 ? $t('手机号码') : $t('请输入邮箱地址')
                    "
                  ></el-input>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="password">
              <div class="register_item">
                <p class="tips">{{ $t('密码') }}</p>
                <div class="input_box">
                  <el-input
                    type="password"
                    v-model="dataList.password"
                    :placeholder="$t('请输入密码')"
                  ></el-input>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="passwordAgain">
              <div class="register_item">
                <p class="tips">{{ $t('确认密码') }}</p>
                <div class="input_box">
                  <el-input
                    type="password"
                    v-model="dataList.passwordAgain"
                    :placeholder="$t('请再次输入密码')"
                  ></el-input>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="registerCode">
              <div class="register_item">
                <p class="tips">{{ $t('邀请码') }}</p>
                <div class="input_box">
                  <el-input
                    v-model="dataList.registerCode"
                    :placeholder="$t('请输入邀请码')"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
          </el-form>

          <i18n
            path="点击注册按钮，代表您同意Z网的《服务条款》和《隐私政策与声明》"
            tag="p"
            class="agreement_box"
          >
            <template v-slot:clause>
              <span class="is_link" @click="jumpTo('agreement', { id: 1 })">{{
                $t('服务条款')
              }}</span>
            </template>
            <template v-slot:statement>
              <span
                place="statement"
                class="is_link"
                @click="jumpTo('agreement', { id: 2 })"
                >{{ $t('隐私政策与声明') }}</span
              >
            </template>
          </i18n>
          <div class="button_box">
            <el-button
              type="primary"
              :loading="loading"
              @click="handleNextstep"
            >
              {{ $t('下一步') }}
            </el-button>
          </div>
        </div>
        <div class="signin_text">
          <p @click="jumpTo('signin')">
            <span>{{ $t('已有账号') }}？ {{ $t('立即登录') }}</span>
            <img src="./../../assets/images/arrowLeft.png" alt="" />
          </p>
        </div>
      </div>
      <SixValidation
        v-model="reverseSix"
        :dataList="dataList"
        type="register"
      ></SixValidation>
    </div>
  </div>
</template>
<script>
import getCode from './mixin/getCode'
import SixValidation from './components/SixValidation'
import InternationalCode from '@/components/internationalCode/index.vue'
export default {
  components: {
    InternationalCode,
    SixValidation
  },
  mixins: [getCode],
  data() {
    const validUsername = (_, value, callback) => {
      if (value === '') {
        switch (this.shimTab) {
          case 0:
            callback(new Error(this.$t('请输入手机号码')))
            break
          case 1:
            callback(new Error(this.$t('请输入邮箱地址')))
            break
        }
      } else {
        callback()
      }
    }
    const validPassword = (rule, value, callback) => {
      const pureNumber = /^[0-9]*$/g
      if (value === '') {
        callback(new Error(this.$t('请输入密码')))
      } else if (pureNumber.test(value)) {
        callback(new Error(this.$t('密码不能是纯数字')))
      } else if (value.length < 8) {
        callback(new Error(this.$t('密码长度8-20位')))
      } else {
        callback()
      }
    }
    const validPasswordAgain = (rule, value, callback) => {
      if (value !== this.dataList.password) {
        callback(new Error(this.$t('两次密码输入不一致')))
      } else {
        callback()
      }
    }
    return {
      registerList: [
        { tab: this.$t('手机'), name: 0 },
        { tab: this.$t('邮箱'), name: 1 }
      ],
      shimTab: 0, // 注册方式 0:手机注册，1:邮箱注册(默认选中：手机注册)
      dataList: {
        account: '', // 用户名（手机号码 或 邮箱）
        registerCode: '', // 邀请码
        password: '', // 密码
        areaCode: '', // 手机国际区号
        areaId: '',
        passwordAgain: '' // 确认密码
      },
      rules: {
        account: [{ validator: validUsername, trigger: 'blur' }],
        password: [{ validator: validPassword, trigger: 'blur' }],
        passwordAgain: [
          {
            required: true,
            message: this.$t('请再次输入密码'),
            trigger: 'blur'
          },
          { validator: validPasswordAgain, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    if (this.$route.query.code) {
      this.dataList.registerCode = this.$route.query.code
    }
  },
  methods: {
    async handleNextstep() {
      await this.$refs.ruleFormRef.validate()
      this.getCaptcha({
        account: this.dataList.account,
        areaCode: this.dataList.areaCode,
        type: 'register'
      })
    },
    onSelectCountry(country) {
      this.dataList.areaId = country.id
      this.dataList.areaCode = country.areaCode
    },
    jumpTo(name, params) {
      if (name === 'agreement') {
        const { href } = this.$router.resolve({ name: name, params: params })
        window.open(href, '_blank')
      } else {
        this.$router.push({ name: name, params: params })
      }
    },
    handleTab(name) {
      this.shimTab = name
      if (this.shimTab) {
        this.dataList.areaCode = ''
        this.dataList.areaId = ''
      }
      this.$refs.ruleFormRef.resetFields()
    }
  }
}
</script>
<style lang="less" scoped>
.register {
  min-height: 835px;
  height: calc(100vh - 60px);
  background: rgba(19, 22, 37, 1);
  .register_box {
    overflow: hidden;
    .register_content {
      .register_card {
        margin: 100px auto 0;
        padding: 38px 40px 40px;
        width: 420px;
        background: #ffffff;
        border-radius: 20px;
        /deep/ .el-form {
          .el-form-item {
            margin-bottom: 20px;
          }
          // 动态控制警告提醒位置（第一个 form-item）
          .mobileFormItem {
            .el-form-item__content {
              .el-form-item__error {
                left: 110px;
              }
            }
          }
        }
        h1 {
          height: 42px;
          font-size: 30px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 42px;
        }
        .tabs_box {
          margin-top: 40px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          div {
            padding-bottom: 2px;
            cursor: pointer;
          }
          div:last-child {
            margin-left: 20px;
          }
          // 动态控制 tab 样式
          .active_tab {
            font-family: PingFangSC-Semibold, 'PingFang SC';
            font-weight: 600;
            color: #1c1b1b;
            border-bottom: 2px solid #c02e21;
          }
        }
        .register_mobile {
          margin-top: 26px;
          display: flex;
          flex-direction: row;
          cursor: pointer;
          .country_code {
            margin-right: 10px;
            padding: 0 10px;
            width: 100px;
            height: 40px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-radius: 4px;
            border: 1px solid rgba(153, 153, 153, 1);
            span {
              font-size: 18px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
            .downdrap {
              width: 30px;
              height: 30px;
            }
          }
          .mobile_box {
            margin-top: 0;
            margin-left: 10px;
            flex-grow: 1;
          }
        }
        .register_email {
          margin-top: 26px;
          cursor: pointer;
          .country_text {
            padding: 0 10px;
            width: 340px;
            height: 40px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-radius: 4px;
            border: 1px solid rgba(153, 153, 153, 1);
            .text {
              font-size: 18px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
            }
            .downdrap {
              width: 30px;
              height: 30px;
            }
          }
          .email_box {
            margin-top: 20px;
          }
        }
        .register_item {
          .tips {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
        }
        /deep/ .input_box {
          margin-top: 10px;
          .element_input_mixin(
            @padding: 8px 10px,
            @width: 100%,
            @height: 40px,
            @fontSize: 18px
          );
        }
        .agreement_box {
          margin-top: 26px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 17px;
        }
        .button_box {
          margin-top: 10px;
          .element_button_mixin(
            @padding: 8px 20px,
            @width: 100%,
            @fontSize: 18px,
            @lineHeight: 22px
          );
        }
      }
      .signin_text {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        p {
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          line-height: 25px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>
